import { User } from "../models";

export function formatName(user?: User | null) {
  return [user?.firstName, user?.secondName]
    .filter(Boolean)
    .join(" ") || '---';
}